module.exports = __webpack_public_path__ + "img/Nick_C_Circle.70839649.png";